/* ==========================================================================
  newsletter-popup.js - Handle newsletter popup with inscription.
========================================================================== */

"use strict";
/* global Toastify, global_ajax */

const newsletterFormPopup = () => {
  const newsletterForm = document.getElementById("generalNewsletterForm");

  if (newsletterForm !== null) {
    /**
     * Modal popup handler
     */
    const newsletterModal = document.getElementById("popupNewsletter");
    const newsletterModalTriggers = document.querySelectorAll(
      ".trigger-popup-newsletter"
    );
    const newsletterModalClose = document.getElementById(
      "closeNewsletterPopup"
    );
    const newsletterModalOverlay = document.getElementById(
      "overlayNewsletterPopup"
    );

    newsletterModalTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        newsletterModal.classList.add("newsletter-popup--active");
      });
    });

    newsletterModalClose.addEventListener("click", () => {
      newsletterModal.classList.remove("newsletter-popup--active");
    });

    newsletterModalOverlay.addEventListener("click", () => {
      newsletterModal.classList.remove("newsletter-popup--active");
    });

    /**
     * Handle the form submission
     */
    newsletterForm.addEventListener("submit", function (event) {
      event.preventDefault(); // prevent the form from submitting

      // disable button and display loading spinner
      const buttonAjax = newsletterForm.querySelector(".button-ajax");
      buttonAjax.disabled = true;
      buttonAjax.classList.add("button-ajax--loading");

      const formData = new FormData(this); // construct the form data
      formData.append("action", "action_general_newsletter"); // add the action
      formData.append("nonce", global_ajax.ajax_nonce); // add the nonce

      fetch(global_ajax.ajax_url, {
        method: "POST",
        body: formData,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          if (!response.success) {
            response.data.forEach((error) => {
              Toastify({
                text: error.message,
                className: "error",
                gravity: "bottom",
                position: "right",
              }).showToast();
            });
          } else {
            Toastify({
              text: response.data.message,
              className: "success",
              gravity: "bottom",
              position: "right",
            }).showToast();
            // reset the form
            newsletterForm.reset();
            newsletterModal.classList.remove("newsletter-popup--active");
          }
        })
        .catch(function (error) {
          console.log(error.message);
        })
        .finally(function () {
          buttonAjax.disabled = false;
          buttonAjax.classList.remove("button-ajax--loading");
        });
    });
  }
};
newsletterFormPopup();
